import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions/permissionEngine';
import type { EstimateResource, ResourceCreatePayload, ResourceUpdatePayload } from '../types/resources.types';

export const resourcesService = {
  async fetchResources() {
    const { data, error } = await supabase
      .from('resources')
      .select(`
        *,
        category:categories!category_id(id, name, code)
      `)
      .order('name', { ascending: true });

    if (error) throw error;
    return (data || []) as unknown as EstimateResource[];
  },

  async createResource(userId: string, companyId: string, payload: ResourceCreatePayload) {
    await permissionEngine.assert(userId, 'inventory.resources.create', { companyId });

    const { data, error } = await supabase
      .from('resources')
      .insert({
        ...payload,
        status: payload.status || 'active',
      })
      .select('id')
      .single();

    if (error) throw error;
    return data.id;
  },

  async updateResource(userId: string, companyId: string, id: string, payload: ResourceUpdatePayload) {
    await permissionEngine.assert(userId, 'inventory.resources.update', { companyId });

    const { error } = await supabase
      .from('resources')
      .update({
        ...payload,
      })
      .eq('id', id);

    if (error) throw error;
    return true;
  },

  async deleteResource(userId: string, companyId: string, id: string) {
    await permissionEngine.assert(userId, 'inventory.resources.delete', { companyId });

    const { error } = await supabase
      .from('resources')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  },
};
